import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const getSizeStyle = (size) => {
    switch (size) {
        case 'sm':
            return css `
        height: ${pxToRem(11)};
        gap: ${pxToRem(1)};
      `;
        case 'md':
            return css `
        height: ${pxToRem(14)};
        gap: ${pxToRem(2)};
      `;
        case 'lg':
            return css `
        height: ${pxToRem(18)};
        gap: ${pxToRem(2)};
      `;
        default:
            return undefined;
    }
};
export const Container = styled.div `
  ${(props) => getSizeStyle(props.$size)};

  display: flex;
  align-items: center;
`;
const getBarHeight = (position, size) => {
    const heightMap = {
        sm: {
            1: pxToRem(4),
            2: pxToRem(9),
            3: pxToRem(6),
        },
        md: {
            1: pxToRem(6),
            2: pxToRem(12),
            3: pxToRem(8),
        },
        lg: {
            1: pxToRem(8),
            2: pxToRem(16),
            3: pxToRem(11),
        },
    };
    return heightMap[size][position];
};
const barStyles = css `
  width: ${pxToRem(2)};
  border-radius: ${pxToRem(4)};
  background-color: ${theme.swatches.warm[500]};
  transform-origin: center;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.45, 0.05, 0.55, 0.95);
`;
const barOneAnimation = keyframes `
  0% {
      transform: scaleY(.40);
      opacity: .5;
  }
  18% {
      transform: scaleY(.85);
      opacity: 1;
  }
  33% {
      transform: scaleY(.55);
      opacity: .65;
  }
  52% {
      transform: scaleY(.95);
      opacity: 1;
  }
  67% {
      transform: scaleY(.45);
      opacity: .55;
  }
  84% {
      transform: scaleY(.78);
      opacity: .9;
  }
  100% {
      transform: scaleY(.40);
      opacity: .5;
  }
`;
const barTwoAnimation = keyframes `
  0% {
    transform: scaleY(.60);
    opacity: .7;
  }
  14% {
      transform: scaleY(.35);
      opacity: .45;
  }
  31% {
      transform: scaleY(.90);
      opacity: 1;
  }
  49% {
      transform: scaleY(.45);
      opacity: .55;
  }
  63% {
      transform: scaleY(1);
      opacity: 1;
  }
  79% {
      transform: scaleY(.55);
      opacity: .65;
  }
  100% {
      transform: scaleY(.60);
      opacity: .7;
  }
`;
const barThreeAnimation = keyframes `
  0% {
      transform: scaleY(.72);
      opacity: .8;
  }
  22% {
      transform: scaleY(.95);
      opacity: 1;
  }
  40% {
      transform: scaleY(.38);
      opacity: .5;
  }
  58% {
      transform: scaleY(.85);
      opacity: .95;
  }
  74% {
      transform: scaleY(.48);
      opacity: .6;
  }
  89% {
      transform: scaleY(.92);
      opacity: 1;
  }
  100% {
      transform: scaleY(.72);
      opacity: .8;
  }
`;
export const BarOne = styled.div `
  animation: ${barOneAnimation} 2.4s;

  ${(props) => `height: ${getBarHeight(1, props.$size)}`};
  ${barStyles};
`;
export const BarTwo = styled.div `
  animation: ${barTwoAnimation} 2.9s;

  ${(props) => `height: ${getBarHeight(2, props.$size)}`};
  ${barStyles};
`;
export const BarThree = styled.div `
  animation: ${barThreeAnimation} 2.6s;

  ${(props) => `height: ${getBarHeight(3, props.$size)}`};
  ${barStyles};
`;
